import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { WishlistButtonWithApi } from '@packages/modules';
import { Box, Image, Stack } from '@packages/shared';
import { Price } from '../../Price';
import { TaxHint } from '../../TaxHint';

const ProductOverviewFragment = graphql(/* GraphQL */ `
  fragment ProductOverviewFragment on Product {
    sku
    name
    price {
      ...ProductPriceFragment
    }
    media {
      type
      url
    }
    delivery {
      deliverySize
    }
    availability {
      state
    }
    ...AddToBasketFragment
  }
`);

type ProductOverviewProps = {
  /**
   * Product data fragment
   */
  productData: FragmentType<typeof ProductOverviewFragment>;
};

/**
 * Product overview component for rating page
 */
export const ProductOverview = ({ productData }: ProductOverviewProps) => {
  const product = getFragmentData(ProductOverviewFragment, productData);
  const {
    media,
    price,
    delivery: { deliverySize },
    sku,
    name,
    availability,
  } = product;

  return (
    <Stack gap={2} flexDirection="row">
      <Box
        sx={{
          width: '100%',
          maxWidth: 196,
          '.ProductOverview-image-wrapper': { position: 'relative', width: '100%', pb: '100%' },
        }}
      >
        <Box className="ProductOverview-image-wrapper">
          <Image
            src={media[0].url}
            style={{
              objectFit: 'contain',
            }}
            fill
            alt=""
            sizes="25vw"
            priority
          />
        </Box>
      </Box>
      <Stack justifyContent="space-between" flexGrow={1}>
        <Stack>
          <Price priceData={price} />
          <TaxHint deliverySize={deliverySize} />
        </Stack>
        <WishlistButtonWithApi
          sku={sku}
          productName={name}
          iconOnly={false}
          availability={availability.state}
        />
      </Stack>
    </Stack>
  );
};
